import FqApi from '@/services/fq-api'

export default {
  async getCapacityDueInOut(isDueOut, dateFrom, dateTo, sortColumn, sortOrder) {
    const result = await FqApi.get('/capacity/getDueInOutCapacity' + '?isDueOut=' + isDueOut + '&dateFrom=' + dateFrom + '&dateTo=' + dateTo + '&sortColumn=' + sortColumn + '&sortOrder=' + sortOrder)
    return result.data
  }
}